import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import PropTypes from 'prop-types';
import {RiskBox} from '../../../index';
import {gatherData, getRiskLabel} from '../../../../shared/utils/utils';
import Table from '../../../../shared/components/Table';
import {getRiskPartner, isEntitled} from '../../../../shared/reducers/user';
import {openRiskPartner} from '../../../utils/partners';
import {Column, Row} from '../../../../shared';
import MgpPoS from '../../../../shared/widgets/MgpPoS';
import {mgpLaunch} from '../../../sections/analyze/Mgp';
import {_openModal} from '../../../../shared/reducers/modals';
import {withSize} from 'react-sizeme';

const AdvisorOverviewTable = ({context, fullPage, size, openModal, rowOnClickDisabled, onRowClick}) => {
  const dataManager = {
    gatherData: gatherData(`/containers/${context?.containerID}/advisors`),
  };
  const riskPartner = getRiskPartner();
  return <Column layout={{grow: 1}}>
    <Table dataManager={dataManager}
           columns={[
             {
               title: 'Advisor',
               dataPoint: 'displayName',
               type: 'text',
               minWidth: 140,
               isSortable: true,
             },
             (fullPage || size.width >= 260)
             && {
               title: 'Assets',
               dataPoint: 'amount',
               type: 'currency',
               minWidth: 120,
               isSortable: true,
             },
             (fullPage || size.width >= 340)
             && {
               title: 'Accounts',
               dataPoint: 'totalAccounts',
               type: 'number',
               minWidth: 80,
               isSortable: true,
             },
             (fullPage || size.width >= 415) && riskPartner
             && {
               title: getRiskLabel(riskPartner),
               dataPoint: 'actualRisk',
               type: 'custom',
               minWidth: 75,
               isSortable: true,
               render: function riskBox(advisor) {
                 return <RiskBox
                   size={'sm'}
                   action={() => openRiskPartner({
                     containerID: (riskPartner === 'stratifi') ? advisor.containerID : undefined,
                   })}
                   riskPartner={riskPartner}
                   riskNumber={advisor.actualRisk}
                   type={'standard'}/>;
               },
             },
             (fullPage || size.width >= 490) && riskPartner
             && {
               title: 'Target Risk',
               dataPoint: 'targetRisk',
               type: 'custom',
               minWidth: 75,
               isSortable: true,
               render: function riskBox(advisor) {
                 return <RiskBox
                   size={'sm'}
                   action={() => openRiskPartner({
                     containerID: (riskPartner === 'stratifi') ? advisor.containerID : undefined,
                   })}
                   riskPartner={riskPartner}
                   riskNumber={advisor.targetRisk}
                   type={'target'}/>;
               },
             },
             (fullPage || size.width >= 590) && isEntitled([{group: 'financialPlanning', feature: 'mgp', access: 'r'}])
             && {
               title: 'Financial Planning',
               dataPoint: 'probabilityOfSuccessPercent',
               type: 'custom',
               minWidth: 100,
               isSortable: true,
               render: function processRow(row) {
                 return <Row>
                   <Column height={'40px'} width={'75px'} justifySubColumn={'middle'} alignItems={'center'}>
                     <MgpPoS isScalable={false}
                             layoutSize={'xs'}
                             action={() => mgpLaunch(row.householdID, openModal)}
                             probabilityOfSuccess={row.probabilityOfSuccess}/>
                   </Column>
                 </Row>;
               },
             },
             (fullPage || size.width >= 670)
             && {
               title: 'Drifted Accounts',
               dataPoint: 'drifted',
               type: 'number',
               minWidth: 80,
               isSortable: true,
             },
           ].filter(c => !!c)}
           rowsPerPage={10}
           searches={[
             {
               title: 'Advisor Name',
               name: 'displayName',
               isFuzzy: true,
             },
           ].filter(s => !!s)}
           defaultSort={{
             column: 'displayName',
             desc: true,
           }}
           rowIdentifier={'id'}
           rowOnClick={onRowClick}
           rowOnClickDisabled={rowOnClickDisabled}/>
  </Column>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default compose(withSize(), connect(mapStateToProps, mapDispatchToProps))(AdvisorOverviewTable);

AdvisorOverviewTable.propTypes = {
  /**
   * The parent calling component context
   */
  context: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    containerID: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  /**
   * Indicates this is a full page and should not have size restrictions
   */
  fullPage: PropTypes.bool,
  /**
   * react-sizeme npm
   */
  size: PropTypes.object,
  /**
   * The open function that dispatches _openModal from Redux
   */
  openModal: PropTypes.func,
  onRowClick: PropTypes.func,
  rowOnClickDisabled: PropTypes.func,
};

